import TrackingConsent from './TrackingConsent';
import { COOKIES_ACCEPTED, MARKETING_ACCEPTED, ConsentCategory } from './constants';

/**
 * Appends current consent state as URL search params.
 * Used on landing pages to propagate consent to the login page (cross-subdomain).
 */
function appendConsentParams(url: string): string {
  if (typeof window === 'undefined') return url;

  const consent = TrackingConsent.getInstance();
  const hasFunctional = consent.hasConsent(ConsentCategory.Functional);
  const hasMarketing = consent.hasConsent(ConsentCategory.Marketing);

  if (!hasFunctional && !hasMarketing) return url;

  try {
    const parsedUrl = new URL(url);

    if (hasFunctional) {
      parsedUrl.searchParams.set(COOKIES_ACCEPTED, 'true');
    }
    if (hasMarketing) {
      parsedUrl.searchParams.set(MARKETING_ACCEPTED, 'true');
    }

    return parsedUrl.toString();
  } catch {
    return url;
  }
}

export default appendConsentParams;
